import { Injectable } from "@angular/core";
import { TPApplication } from "../api-generated/model/tPApplication";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalApplicationService extends BaseService<TPApplication> {}
